// Shopify GraphQL API versions — bumped deliberately in code, not per-environment.
export const SHOPIFY_ADMIN_API_VERSION = "2026-01";
export const STOREFRONT_API_VERSION = "2026-01";

export const adminGraphqlUrl = (storeDomain: string): string =>
  `https://${storeDomain}/admin/api/${SHOPIFY_ADMIN_API_VERSION}/graphql.json`;

export const storefrontGraphqlUrl = (storeDomain: string): string =>
  `https://${storeDomain}/api/${STOREFRONT_API_VERSION}/graphql.json`;
